import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { MotifTheme } from "@ey-xd/motif-react";
import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
} from "react-router-dom";
import { EventType } from "@azure/msal-browser";
import { AppRoutes } from "./routes/app-routes";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./configs/authConfig";
import { initializeI18n } from "./configs/i18n";
import { DomainProvider } from "./configs/domainContext";

const router = createBrowserRouter(createRoutesFromElements(AppRoutes));

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () => {
  root.render(
    <>
      <DomainProvider>
        <MsalProvider instance={msalInstance}>
          <MotifTheme variant="dark" />

          <RouterProvider router={router} />
        </MsalProvider>
      </DomainProvider>
    </>,
  );
};

const bootstrap = async () => {
  try {
    await msalInstance.initialize();

    const existingAccounts = msalInstance.getAllAccounts();
    if (existingAccounts.length > 0 && !msalInstance.getActiveAccount()) {
      msalInstance.setActiveAccount(existingAccounts[0]);
    }

    msalInstance.addEventCallback((event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        event.payload?.account
      ) {
        msalInstance.setActiveAccount(event.payload.account);
      }
    });

    await msalInstance.handleRedirectPromise();
  } catch (error) {
    console.error("MSAL initialization failed", error);
  }

  await initializeI18n().catch((error) => {
    console.error("i18n initialization failed", error);
  });

  renderApp();
};

bootstrap();

reportWebVitals();
